export const SvgDownload = '%3Csvg%20xmlns%3D"http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg"%20viewBox%3D"0%200%2030%2030"%3E%3Cpath%20d%3D"M0%2027.55h30V30H0zM16.21%2022.66V0h-2.38v22.66L2.45%2011.21v3.29l12.57%2012.61%2012.53-12.59v-3.29z"%2F%3E%3C%2Fsvg%3E';
export default SvgDownload;
